<template>
    <div class="view-factory-page">
        <base-header
            class="factory-main-page__header"
            :titulo="translate_view_factory('main_title')"
            :voltarPara="true"
        />
        <div class="view-container-wrapper">
            <div class="content">
                <section class="factory_section" v-if="factoryId">
                    <div class="factory_card" v-loading="loadingFactory">
                        <div class="factory-info_header">
                            <h3 class="factory-info_title">
                                <i class="mdi mdi-factory"></i>
                                {{ translate_view_factory('factory_data') }}
                            </h3>
                        </div>
                        <div class="factory-info">
                            <div class="factory-info_field">
                                <span class="factory-info_label">{{
                                    translate_view_factory('id_lyra')
                                }}</span>
                                <span class="factory-info_text">{{
                                    checkValidInformation(
                                        factoryInformation?.idLyra
                                    )
                                }}</span>
                            </div>
                            <div class="factory-info_field">
                                <span class="factory-info_label">{{
                                    translate_view_factory(
                                        'individual_registration_number'
                                    )
                                }}</span>
                                <span class="factory-info_text">{{
                                    checkValidInformation(
                                        factoryInformation?.registroIndustrial
                                    )
                                }}</span>
                            </div>
                            <div class="factory-info_field">
                                <span class="factory-info_label">{{
                                    translate_view_factory('ruc')
                                }}</span>
                                <span class="factory-info_text">{{
                                    checkValidInformation(
                                        factoryInformation?.ruc
                                    )
                                }}</span>
                            </div>
                            <div class="factory-info_field">
                                <span class="factory-info_label">{{
                                    translate_view_factory('legal_name')
                                }}</span>
                                <span class="factory-info_text">{{
                                    checkValidInformation(
                                        factoryInformation?.razaoSocial
                                    )
                                }}</span>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="factory_section" v-if="factoryId">
                    <div class="factory_card" v-loading="loadingFactory">
                        <div class="factory-info_header">
                            <h3 class="factory-info_title">
                                <i class="el-icon-location-information"></i>
                                {{ translate_view_factory('location') }}
                            </h3>
                        </div>
                        <div class="factory-info factory-info--four">
                            <div class="factory-info_field">
                                <span class="factory-info_label">{{
                                    translate_view_factory('department')
                                }}</span>
                                <span class="factory-info_text">{{
                                    checkValidInformation(
                                        factoryInformation?.departamento
                                    )
                                }}</span>
                            </div>
                            <div class="factory-info_field">
                                <span class="factory-info_label">{{
                                    translate_view_factory('district')
                                }}</span>
                                <span class="factory-info_text">{{
                                    checkValidInformation(
                                        factoryInformation?.distrito
                                    )
                                }}</span>
                            </div>
                            <div class="factory-info_field">
                                <span class="factory-info_label">{{
                                    translate_view_factory('address')
                                }}</span>
                                <span class="factory-info_text">{{
                                    checkValidInformation(
                                        factoryInformation?.endereco
                                    )
                                }}</span>
                            </div>
                            <div class="factory-info_field">
                                <span class="factory-info_label">{{
                                    translate_view_factory('coordinates')
                                }}</span>
                                <span class="factory-info_text">
                                    {{
                                        checkValidInformation(
                                            factoryInformation?.latitude
                                        )
                                    }}
                                    /
                                    {{
                                        checkValidInformation(
                                            factoryInformation?.longitude
                                        )
                                    }}
                                </span>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="factory_section" v-if="factoryId">
                    <div class="factory_totalizers">
                        <totalizer-block
                            :text="translate_view_factory('produced_volume')"
                            :number="
                                formatTextTotalizerRow(
                                    totalizers?.volumeProduzido?.volumeTotalTon,
                                    't'
                                )
                            "
                            :detailedInformation="
                                sortProducts(
                                    totalizers.volumeProduzido?.produtos || null
                                )
                            "
                            iconClass="lyra-icon lyra-volume"
                        />

                        <totalizer-block
                            :text="translate_view_factory('shipped_volume')"
                            :number="
                                formatTextTotalizerRow(
                                    totalizers?.volumeEmbarcado?.volumeTotalTon,
                                    't'
                                )
                            "
                            :detailedInformation="
                                sortProducts(
                                    totalizers.volumeEmbarcado?.produtos || null
                                )
                            "
                            iconClass="lyra-icon lyra-volume-vendido"
                        />

                        <totalizer-block
                            :text="translate_view_factory('available_volume')"
                            :number="
                                formatTextTotalizerRow(
                                    totalizers?.volumeDisponivel?.volumeTotalTon,
                                    't'
                                )
                            "
                            :detailedInformation="
                                sortProducts(
                                    totalizers.volumeDisponivel?.produtos ||
                                        null
                                )
                            "
                            iconClass="lyra-icon lyra-fabrica"
                        />

                        <totalizer-block
                            :text="translate_view_factory('export_volume')"
                            :number="
                                formatTextTotalizerRow(
                                    totalizers?.volumeParaExportacao
                                        ?.volumeTotalTon,
                                    't'
                                )
                            "
                            :detailedInformation="
                                sortProducts(
                                    totalizers.volumeParaExportacao?.produtos ||
                                        null
                                )
                            "
                            iconClass="lyra-icon lyra-transfer"
                        />
                    </div>
                </section>

                <section class="factory-loan-control_section">
                    <div class="factory-loan-control_section_header">
                        <h3 class="loan-control_section_title">
                            {{ translate(`view_loan_modal.loan_management`) }}
                        </h3>

                        <div>
                            <el-button
                                slot="reference"
                                type="text"
                                class="view-statement__btn"
                                @click="
                                    showModalViewStatement = !showModalViewStatement
                                "
                            >
                                {{ translate(`view_loan_modal.view_statement`) }}
                            </el-button>
                        </div>
                    </div>

                    <div class="counter-blocks_section" v-if="Object.keys(formattedLoanData).length > 0">
                        <simple-counter-block
                            v-if="formattedLoanData.volumeRecebido"
                            iconClass="lyra-icon lyra-flecha-cima-circulada"
                            :data="formattedLoanData.volumeRecebido"
                        />
                        <simple-counter-block
                            v-if="formattedLoanData.volumeEnviado"
                            iconClass="lyra-icon lyra-flecha-baixo-circulada"
                            :data="formattedLoanData.volumeEnviado"
                        />
                        <simple-counter-block
                            v-if="formattedLoanData.saldo"
                            title="Saldo"
                            :data="formattedLoanData.saldo"
                        />
                    </div>
                </section>

                <section class="factory_section" v-if="factoryId">
                    <div class="factory-info_header">
                        <h3 class="operations_history_section_title">
                            {{ translate_view_factory('operations_list') }}
                        </h3>
                    </div>

                    <div class="main-filters">
                        <div class="main-filters">
                            <div class="main-filters__search">
                                <el-input
                                    v-model="searchText"
                                    style="width: 100%"
                                    :placeholder="
                                        translate(
                                            'messages.main_filter.search_operation_label'
                                        )
                                    "
                                    @input="pesquisar"
                                >
                                    <template #prefix>
                                        <i class="el-icon-search"></i>
                                    </template>
                                </el-input>
                                <el-popover
                                    v-model="showModalAdvancedFilters"
                                    trigger="manual"
                                    :width="570"
                                    :offset="0"
                                >
                                    <template #reference>
                                        <el-button
                                            slot="reference"
                                            type="text"
                                            icon="el-icon-s-operation"
                                            class="main-filters__btn_advanced_filters"
                                            @click="
                                                showModalAdvancedFilters =
                                                    !showModalAdvancedFilters
                                            "
                                        >
                                            {{
                                                translate(
                                                    'messages.main_filter.btn_advanced_filters'
                                                )
                                            }}
                                        </el-button>
                                    </template>
                                    <template #default>
                                        <dialog-advanced-filters
                                            @handleFilter="handleFilter"
                                            @applyFilter="applyFilter"
                                            @clear="clearFilters"
                                            :show="showModalAdvancedFilters"
                                            :excludeInvoice="true"
                                        />
                                    </template>
                                </el-popover>
                            </div>
                        </div>
                    </div>

                    <factory-transaction-list
                        class="transaction-list"
                        :filters="filters"
                    />
                </section>
            </div>
        </div>
        <view-statement-modal
            v-if="showModalViewStatement"
            :show="showModalViewStatement"
            :selectedFacilityLoan="factoryId"
            @close="closeModal()"
        />
    </div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import IndustriaModuleService from '@/services/IndustriaModuleService';
import TotalizerBlock from '@/modules/warehouse/views/components/TotalizerBlock.vue';
import FactoryTransactionList from '@/modules/warehouse/views/pages/viewFactory/components/transaction-list/index.vue';
import formatters from '@/utils/formatters';
import DialogAdvancedFilters from '@/modules/warehouse/views/pages/main/components/filters/dialog-advanced-filters.vue';
import SimpleCounterBlock from '@/modules/warehouse/views/components/SimpleCounterBlock.vue';
import ViewStatementModal from '@/modules/warehouse/views/pages/viewWarehouse/components/view-statement-modal/index.vue';
import { mapState, mapActions } from 'vuex';

export default {
    name: 'ViewFactoryPage',
    components: {
        DialogAdvancedFilters,
        BaseHeader,
        TotalizerBlock,
        FactoryTransactionList,
        SimpleCounterBlock,
        ViewStatementModal
    },
    data() {
        return {
            factoryId: this.$route.params.factoryId,
            viewPendingOperations: this.$route.params.viewPendingOperations,
            factoryInformation: {},
            totalizers: {},
            filters: {
                searchText: '',
                idArmazem: this.$route.params.factoryId,
                origin: null,
                destination: null,
                initialDate: null,
                endDate: null,
                operationTypes: []
            },
            advancedFilters: {},
            searchText: '',
            showModalAdvancedFilters: false,
            loadingFactory: false,
            productOrder: {
                FARINHA: 1,
                OLEO: 2,
                CASCA: 3
            },
            showModalViewStatement: false,
            formattedLoanData: {}
        };
    },
    mounted() {
        if (!this.factoryId && (this.viewPendingOperations !== 'transacoes-pendentes' && this.viewPendingOperations !== 'troca-titularidade-pendentes')) {
            this.$router.push({ name: 'saldoArmazem' });
        } else {
            this.fetchFactoryInformation();
            this.fetchFactoryTotalizers();
            this.fetchLoanTotalizer(this.factoryId);
        }
    },
    computed: {
        ...mapState('warehouseModule', ['loanTotalizers'])
    },
    watch: {
        '$route.params.factoryId': {
            immediate: false,
            handler(newId) {
                if (newId) {
                    this.factoryId = newId;
                    this.fetchFactoryInformation();
                    this.fetchFactoryTotalizers();
                }
            }
        },
        '$route.params.viewPendingOperations': {
            immediate: false,
            handler(newVal) {
                this.viewPendingOperations = newVal;
            }
        },
        loanTotalizers: {
            handler(newVal) {
                this.processarDadosTotalizadores();
            },
            deep: true
        },
        '$i18n.locale': {
            handler() {
                this.processarDadosTotalizadores();
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        if (to.path.includes('/armazem/saldo')) {
            this.$store.commit(
                'warehouseModule/SET_MAIN_SELECTED_TAB',
                'factories-tab'
            );
        }
        next();
    },
    methods: {
        ...mapActions('warehouseModule', ['fetchLoanTotalizer']),
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$tc(`${base}.${key}`, params);
        },
        translate_view_factory(key, params = {}) {
            const base = 'warehouse.view_factory';
            return this.$t(`${base}.${key}`, params);
        },
        changeFilters(filters) {
            if (filters !== null) {
                this.filters.origin = filters.origin;
                this.filters.endDate = filters.endDate;
                this.filters.destination = filters.destination;
                this.filters.operationTypes = filters.operationTypes;
                this.filters.initialDate = filters.initialDate;
                this.filters.searchText = this.searchText;
            }
        },
        handleFilter(filters) {
            this.advancedFilters = filters;
            this.changeFilters(filters);
            this.showModalAdvancedFilters = false;
        },
        clearFilters() {
            this.showModalAdvancedFilters = false;
            this.filters = {
                searchText: '',
                idArmazem: this.factoryId,
                origin: null,
                destination: null,
                initialDate: null,
                endDate: null,
                operationTypes: []
            };

            this.pesquisar();
        },
        applyFilter() {
            this.$emit('changeFilters', this.formatFilters());
            this.showModalAdvancedFilters = false;
        },
        pesquisar() {
            this.changeFilters(this.filters);
        },
        async fetchFactoryTotalizers() {
            try {
                const { data } =
                    await IndustriaModuleService.getFactoryTotalizers(
                        this.factoryId
                    );

                this.totalizers = data;
            } catch (e) {
                this.$notify.error({
                    message: this.translate('messages.error_fetching_totalizers')
                });
            }
        },
        async fetchFactoryInformation() {
            try {
                this.loadingFactory = true;
                const { data } =
                    await IndustriaModuleService.getFactoryInformation(
                        this.factoryId
                    );
                this.factoryInformation = data;
            } catch (e) {
                this.$notify.error({
                    message: this.translate(
                        'messages.error_fetching_factory_information'
                    )
                });
            } finally {
                this.loadingFactory = false;
            }
        },
        checkValidInformation(info) {
            return info || '-';
        },
        formatTextTotalizerRow(data, text) {
            if (data !== 0 && (!data || data === '')) {
                return null;
            } else if (data === '-') {
                return data;
            } else {
                return formatters.minFormatNumber(data, 2, this.$i18n.locale) + (!text ? '' : (' ' + text));
            }
        },
        sortProducts(products) {
            if (!products || products.length === 0) {
                return [];
            }

            const formattedItems = products.map(({ codigo, codigoNcm, volumeTon }) => ({
                codigo: codigo,
                label: this.translate('messages.' + codigo.toLowerCase()) + ` (${codigoNcm})`,
                value: this.formatTextTotalizerRow(volumeTon, 't')
            }));
            return [...formattedItems].sort((a, b) => {
                return (
                    this.productOrder[a.codigo] - this.productOrder[b.codigo]
                );
            });
        },
        formatFilters() {
            return {
                operationTypes: [],
                initialDate: '',
                searchText: '',
                endDate: '',
                origin: '',
                destination: ''
            };
        },
        closeModal() {
            this.showModalViewStatement = false;
        },
        processarDadosTotalizadores() {
            if (!this.loanTotalizers) {
                this.formattedLoanData = {};
                return;
            }

            const formattedLoanData = {};

            Object.keys(this.loanTotalizers).forEach(key => {
                formattedLoanData[key] = {
                    detailText: this.translate(`messages.this_month`),
                    value: this.formatNumber(this.loanTotalizers[key].volumeTotalTon).toString() + ' t',
                    detailValue: this.formatNumber(this.loanTotalizers[key].volumeMensalTon).toString() + ' t'
                };

                if (key === 'volumeRecebido') {
                    formattedLoanData[key].counterColor = '#193CB8';
                    formattedLoanData[key].title = this.translate(`messages.received_volume`);
                } else if (key === 'volumeEnviado') {
                    formattedLoanData[key].counterColor = '#388E3C';
                    formattedLoanData[key].title = this.translate(`messages.sent_volume`);
                } else if (key === 'saldo') {
                    formattedLoanData[key].counterColor = this.loanTotalizers[key].volumeTotalTon >= 0 ? '#3B3B3B' : '#E41B1B';
                    formattedLoanData[key].detailColor = this.loanTotalizers[key].volumeMensalTon >= 0 ? '#3B3B3B' : '#E41B1B';
                    formattedLoanData[key].title = this.translate(`messages.balance`);
                }
            });

            this.formattedLoanData = formattedLoanData;
        },

        formatNumber(value) {
            if (value === null || value === undefined) return '-';
            return formatters.minFormatNumber(value, 2, this.$i18n.locale);
        }
    }
};
</script>

<style scoped lang="scss">
.view-factory-page {
    .view-container-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .main-filters {
        .main-filters__search {
            display: grid;
            grid-template-columns: 1fr auto;
            gap: 16px;
            @media (max-width: 768px) {
                grid-template-columns: 1fr;
            }

            .el-input {
                i.el-icon-search {
                    color: #183b57;
                    font-size: 20px;
                    margin: 10px 2px;
                }
            }

            .main-filters__btn_advanced_filters {
                border: 1px solid #183b57;
                font-size: 14px;
                padding: 9px 16px;
                height: 40px;
            }
        }

        .main-filters__selected {
            > h3 {
                margin: 16px 0;
                color: #3b3b3b;
                font-weight: 500;
                font-size: 16px;
                padding-right: 10px;
            }

            > span {
                font-style: italic;
            }

            display: flex;
            align-items: center;

            .main-filters__selected__options {
                display: flex;
                align-items: center;

                .el-icon {
                    box-sizing: border-box;
                }

                .el-icon:hover {
                    background-color: rgba(255, 255, 255, 0.4);
                    border-radius: 100%;
                }

                .main-filters__selected__options_content {
                    display: flex;

                    .main-filters__selected__options_status {
                        display: inline-flex;
                        padding-right: 5px;
                        text-transform: capitalize;
                    }
                }

                .el-button {
                    background-color: #359138;
                    color: white;
                    font-size: 12px;
                    text-transform: lowercase;
                    display: flex;
                }

                .main-filters__selected__options_status_clear {
                    background-color: #ebf4eb;
                    color: #359138;
                    font-weight: 300;
                    font-size: 12px;
                    align-items: center;
                }
            }
        }
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
        .transaction-list {
            margin-top: 0px !important;
        }

        .counter-blocks_section {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 16px;
        }
    }

    .factory_section {
        display: grid;
        grid-template-columns: 100%;
        gap: 16px;

        .operations_history_section_title {
            color: var(--float-box-section-title-color, #666666);
            font-weight: 700;
            font-size: 16px;
            margin: 12px 0 0 0;
        }
    }
    .factory_card {
        padding: 16px;
        background: white;
        border-radius: 5px;
        font-size: 14px;

        .factory-info {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 12px 16px;

            @media (max-width: 1200px) {
                grid-template-columns: repeat(2, 1fr);
            }
            @media (max-width: 768px) {
                grid-template-columns: 1fr;
            }
        }
        .factory-info--four {
            grid-template-columns: repeat(4, 1fr);

            @media (max-width: 1200px) {
                grid-template-columns: repeat(2, 1fr);
            }
            @media (max-width: 768px) {
                grid-template-columns: 1fr;
            }
        }
        .factory-info_header {
            margin-bottom: 16px;
            display: grid;
            grid-template-columns: 3fr;
        }
        .factory-info_title {
            color: #00413c;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 8px;
        }
        .factory-info_field {
            display: flex;
            flex-direction: column;
        }
        .factory-info_label {
            color: #00413c;
            font-weight: 600;
            line-height: 1.2;
            margin-bottom: 4px;
        }
        .factory-info_text {
            word-break: break-word !important;
            line-height: 1.4;
        }
    }

    .factory_totalizers {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 16px;
    }

    .factory-loan-control_section {
        display: grid;
        grid-template-columns: 100%;
        gap: 16px;
        margin-top: 8px;
    }

    .factory-loan-control_section_header {
        margin-bottom: 0;
        display: flex;
        justify-content: space-between;
    }

    .loan-control_section_title {
        color: var(--float-box-section-title-color, #666666);
        font-weight: 700;
        font-size: 16px;
        margin: 12px 0 0 0;
    }

    .view-statement__btn {
        border: 1px solid #183b57;
        font-size: 14px;
        padding: 9px 16px;
        height: 40px;
    }
}
</style>
